// DS: i7.6
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const EditorAlignJustify: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path
          fillRule="evenodd"
          d="M19 13a1 1 0 100-2H5a1 1 0 100 2h14zm0 6a1 1 0 100-2H5a1 1 0 100 2h14zm0-14a1 1 0 110 2H5a1 1 0 110-2h14z"
          clipRule="evenodd"
        ></path>
      </svg>
    </IconWrap>
  );
};
EditorAlignJustify.displayName = 'EditorAlignJustify';

export default EditorAlignJustify;
